import {
  Component,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  OnInit,
  ElementRef,
  ViewChild,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UtilityHelper } from '../../../../core/helper/utility-helper';
import { WebService } from '../../../../core/services/web-service/web.service';
import { environment } from '../../../../../environments/environment';
import feather from 'feather-icons';
import { AuthService } from '../../../../core/services/authentication/auth.service';
declare var $: any;
import Splide from '@splidejs/splide';
import { RemoveHtmlPipe } from '../../../../pipes/remove-html.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppConstants } from '../../../../core/constant/app.constant';
import { Subscription } from 'rxjs';
import { FirebaseService } from '../../../../core/services/firebase.service';

@Component({
  selector: 'app-product-detail',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    RemoveHtmlPipe,
    MatTooltipModule,
  ],
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
})
export class ProductDetailComponent
  implements AfterViewInit, OnChanges, OnInit
{
  isLoading: boolean = false;
  isCartLoading: boolean = false;
  IsnotifyMe: boolean = false;
  imageBaseUrl = environment.imageBaseUrl;
  domiImageBaseUrl = environment.domiImageBaseUrl;
  productId: any = '';
  DataList: any = {};
  similarProductDataList: any[] = [];
  product_images: any[] = [];
  variations: any[] = [];
  activeTerms: { [key: number]: number } = {};
  filteredVariation: any;
  filteredVariationData: any;
  firstVariationImagePath: string = '';
  variationsCodeToFilter = '';
  price: any;
  product_id: any;
  product_type: any;
  variant_id: any;
  termIdsToSelect: any = '';
  ResponseData: any;
  currentUserId: any = null;
  quantity = 1;
  pagination = {
    totalElements: 0,
    page: 0,
    size: 6,
  };
  payload: any;

  product: any = '';
  attrVariationDataList: any;
  isModalOpen: boolean = false;
  similarProduct = true;
  percentage: any = 0;
  isLoadingqty: boolean = false;
  cartQuantity: any = '';
  cartPrice: any = '';
  productLink: any = '';
  productName: string = '';
  constructor(
    private route: ActivatedRoute,
    private WebService: WebService,
    private router: Router,
    private utility: UtilityHelper,
    private AuthService: AuthService,
    private firebaseService: FirebaseService
  ) {
     this.productLink = window.location.origin + this.router.url;
     console.log("aSaS",this.productLink);

    var categoryId = localStorage.getItem(AppConstants.localStorage.categoryId);
    this.payload = {
      pageIndex: 0,
      pageSize: this.pagination.size,
      sortBy: '',
      searchBy: '',
      sortingOrder: '',
      status: 1,
      categoryId: categoryId,
      subCategoryId: '',
      sortByProduct: '',
      minMaxPrice: '',
      verientdata: '',
      userId: '',
      warehouse_id: 1,
    };
    this.route.params.subscribe((params) => {
      const encryptedId = params['productId'];
      this.productId = parseInt(
        this.utility.decryptLinkParams(encryptedId),
        10
      );
    });
    var offerDetail = localStorage.getItem(
      AppConstants.localStorage.offerDetail
    );
    if (offerDetail) {
      var parsedOfferDetail = JSON.parse(offerDetail); // Parse JSON string
      if (parsedOfferDetail.productId == this.productId) {
        this.percentage = parsedOfferDetail.percent.percentage;
      } else {
        this.percentage = 0;
      }
    }
    // if (this.similarProduct == true) {

    const urlSegments = this.route.snapshot.url;
    // if (urlSegments.length >= 2) {
    this.variationsCodeToFilter = urlSegments[urlSegments.length - 2].path; // e.g., "3-4"
    // }
    this.termIdsToSelect = this.variationsCodeToFilter
      .split('-')
      .map((id) => parseInt(id, 10));
    // }
  }
  private subscription!: Subscription;

  // @ViewChild('mainImageWrapper') mainImageWrapper!: ElementRef;
  // @ViewChild('mainImage') mainImage!: ElementRef;

  // onMouseMove(event: MouseEvent) {
  //   const container = this.mainImageWrapper.nativeElement;
  //   const image = this.mainImage.nativeElement;

  //   const containerRect = container.getBoundingClientRect();
  //   const x = event.clientX - containerRect.left;
  //   const y = event.clientY - containerRect.top;

  //   const translateX = (container.offsetWidth / 2 - x) * 2;
  //   const translateY = (container.offsetHeight / 2 - y) * 2;
  //   const scale = 2;

  //   image.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
  // }

  // onMouseLeave() {
  //   const image = this.mainImage.nativeElement;
  //   image.style.transform = 'translate(0%, 0%) scale(1)';
  // }

  @ViewChild('image') image!: ElementRef;
  @ViewChild('lens') lens!: ElementRef;

  // magnifier effect lanse image
  zoomImage(event: MouseEvent) {
    const image = this.image.nativeElement;
    const lens = this.lens.nativeElement;

    const { left, top, width, height } = image.getBoundingClientRect();
    const lensSize = lens.offsetWidth / 2 ;

    let x = event.clientX - left;
    let y = event.clientY - top;

    if (x < lensSize) x = lensSize;
    if (y < lensSize) y = lensSize;
    if (x > width - lensSize) x = width - lensSize;
    if (y > height - lensSize) y = height - lensSize;

    lens.style.left = `${x - lensSize}px`;
    lens.style.top = `${y - lensSize}px`;
    lens.style.display = 'block';

    // **Increase zoom size dynamically based on image size**
    const zoomLevel = 1; // Adjust zoom intensity
    const zoomWidth = width * zoomLevel;
    const zoomHeight = height * zoomLevel;

    lens.style.backgroundImage = `url(${image.src})`;
    lens.style.backgroundSize = `${zoomWidth}px ${zoomHeight}px`;
    lens.style.backgroundPosition = `-${(x / width) * zoomWidth}px -${
      (y / height) * zoomHeight
    }px`;
  }

  hideLens() {
    this.lens.nativeElement.style.display = 'none';
  }
  encryptId(id: any): string {
    return this.utility.encryptLinkParams(id.toString());
  }
  ngOnInit(): void {
    this.getCurrentUser();
    this.getProductDetail();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.getProductDetail();
      }
    });
    this.fetchAllProduct();
    this.WebService.productData$.subscribe((data) => {
      if (data?.status === 200) {
        this.similarProductDataList = data.data.content;
      } else {
        this.similarProductDataList = [];
      }
    });
    this.subscription = this.WebService.cartItemRemoved$.subscribe((cartId) => {
      this.similarProductDataList = this.similarProductDataList.map(
        (product: any) => {
          if (product.id == cartId) {
            product.cart = false;
          }
          if (this.DataList.id == cartId) {
            product.cart = false;
          }
          return product;
        }
      );
    });
    this.subscription = this.WebService.cartItemRemoved$.subscribe((cartId) => {
      if (this.DataList.id == cartId) {
        this.DataList.cart = false;
      }
    });
    this.reinitializeSlick();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  ngAfterViewInit(): void {
    //  this.reinitializeSlick();
    feather.replace();
  }
  ngAfterViewChecked() {
    feather.replace(); // Reinitialize Feather icons
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['product_images'] && this.product_images?.length) {
      // this.initializeSlick();
    }
  }
  ImageUrls(data: any) {
    this.firstVariationImagePath = data;
  }
  getCurrentUser(): void {
    const token = localStorage.getItem(AppConstants.localStorage.authToken);
    if (token) {
      this.currentUserId = this.AuthService.userId;
    }
  }
  getProductDetail(): void {
    // this.isLoading = true;
    this.WebService.getProductById(
      this.productId,
      this.currentUserId
    ).subscribe((response: any) => {
      if (response?.status === 200) {
        this.DataList = response.data;
        this.ResponseData = response;
        this.cartQuantity = response.data.quantity;
        this.cartPrice = response.data.cartPrice;
        this.variations = response.data.variations || [];
        this.setDefaultActiveTerms(this.termIdsToSelect);
        this.product_id = response.data.id;
        this.processProductDetails(response, this.variationsCodeToFilter);
        this.reinitializeSlick();
      } else {
        console.error('Product not found');
      }
      // this.isLoading = false;
    });
  }
  addToWishlistdetail(): void {
    if (this.currentUserId) {
      const payload = {
        user_id: this.currentUserId,
        product_id: this.product_id,
      };
      this.WebService.addWishlist(payload).subscribe({
        next: (res: any) => {
          if (res?.status === 200) {
            this.utility.toastAlert('success', res.message);
            if (this.DataList) {
              this.DataList.wishlist = true;
            }
            //  this.getProductDetail();
          } else {
            this.utility.toastAlert('error', res.message);
          }
          this.isLoading = false;
        },
        error: (error: any) => {
          this.isLoading = false;
          this.utility.toastAlert(
            'error',
            error.message || 'An error occurred'
          );
        },
      });
    } else {
      this.router.navigate(['users/account/sign-in']);
    }
  }
  removeToWishlist(id: any): void {
    if (this.currentUserId) {
      this.WebService.removeWishlistProduct(id, this.currentUserId).subscribe(
        (response: any) => {
          if (response?.status === 200) {
            this.similarProductDataList = this.similarProductDataList.map(
              (product: any) => {
                if (product.id === id) {
                  product.wishlist = false;
                }
                return product;
              }
            );
          } else {
            this.utility.toastAlert('error', response.message);
          }
        }
      );
    } else {
      this.router.navigate(['users/account/sign-in']);
    }
  }
  plusMinusQuantities(action: string): void {
    if (action === 'plus') {
      this.quantity++;
    } else if (action === 'minus' && this.quantity > 1) {
      this.quantity--;
    }
  }

  addToCart(): void {
    this.isCartLoading = true;
    if (this.currentUserId) {
      const payload = {
        user_id: this.currentUserId,
        product_id: this.product_id,
        quantity: this.quantity,
        product_type: this.product_type,
        variant_id: this.variant_id,
        currentPrice:
          this.percentage > 0
            ? this.price - (this.price * this.percentage) / 100
            : this.price,
      };

      this.WebService.addToCart(payload).subscribe({
        next: (res: any) => {
          if (res?.status === 200 && res.data) {
            this.utility.toastAlert('success', res.message);
            this.WebService.triggerReload();
            if (this.DataList) {
              this.cartQuantity = this.quantity;
              this.DataList.cart = true;
              this.cartPrice = +this.price;
            }
            // this.getProductDetail();
          } else {
            this.utility.toastAlert('error', res.message);
          }
          this.isCartLoading = false;
        },
        error: (error: any) => {
          this.isCartLoading = false;
          this.utility.toastAlert(
            'error',
            error.message || 'An error occurred'
          );
        },
      });
    } else {
      this.router.navigate(['users/account/sign-in']);
    }
  }
  async notifyMe(): Promise<void> {
    this.IsnotifyMe = true;
    // const token = await this.firebaseService.requestPermission();
    const token = null;
    if (this.currentUserId) {
      const payload = {
        user_id: this.currentUserId,
        product_id: this.product_id,
        variant_id: this.variant_id ? this.variant_id : null,
      };
      this.WebService.notifyMe(payload).subscribe({
        next: (res: any) => {
          if (res?.status === 200) {
            this.utility.toastAlert('success', res.message);
          } else {
          }
          this.IsnotifyMe = false;
        },
        error: (error: any) => {
          this.IsnotifyMe = false;
          this.utility.toastAlert('error', error.message);
        },
      });
    } else {
      this.router.navigate(['users/account/sign-in']);
    }
  }
  processProductDetails(response: any, variationsCodeToFilter: any): void {
    this.productName = this.DataList?.product_name;
    if (this.DataList.product_type == 1) {
      this.product_type = response.data.product_type;
      const selectedVariation = this.variations.find(
        (variation: any) => variation.variations_code === variationsCodeToFilter
      );

      if (selectedVariation) {
        this.variant_id = selectedVariation.id || 0;
        this.filteredVariationData = selectedVariation || '';
        this.price =
          selectedVariation.discount_price ||
          selectedVariation.variations_price ||
          response.data.discount_price ||
          response.data.selling_price ||
          '';
        this.filteredVariation =
          selectedVariation.images || response.data.product_images || '';
        this.firstVariationImagePath =
          selectedVariation.images?.[0]?.image_path ||
          this.DataList.product_images?.[0]?.image_path ||
          this.DataList.product_thumbnail ||
          '';
      } else {
        this.variant_id = 0;
        this.filteredVariationData = '';
        this.price =
          response.data.discount_price || response.data.selling_price || '';
        this.filteredVariation = response.data.product_images || '';
        this.firstVariationImagePath =
          this.DataList.product_images?.[0]?.image_path ||
          this.DataList.product_thumbnail ||
          '';
      }
      feather.replace();
      this.reinitializeSlick();
    } else {
      this.product_type = 0;
      this.filteredVariationData = '';
      this.price =
        response.data.discount_price || response.data.selling_price || '';
      this.filteredVariation = response.data.product_images || '';
      this.firstVariationImagePath =
        this.DataList.product_images?.[0]?.image_path ||
        this.DataList.product_thumbnail ||
        '';
    }
    feather.replace();
  }

  setDefaultActiveTerms(termIdsToSelect: any): void {
    this.DataList.attributeTermData.forEach((attributeData: any) => {
      const matchingTerm = attributeData.terms.find((term: any) =>
        termIdsToSelect.includes(term.id)
      );
      if (matchingTerm) {
        this.activeTerms[attributeData.id] = matchingTerm.id;
      }
    });
  }

  setActiveTerm(attributeId: any, termId: number): void {
    // delete this.activeTerms[attributeId];
    this.activeTerms = { ...this.activeTerms, [attributeId]: termId };
    // this.activeTerms[attributeId] = termId;

    this.updateVariationsCodeToFilter();
  }

  updateVariationsCodeToFilter(): void {
    const selectedTerms = Object.values(this.activeTerms);
    this.variationsCodeToFilter = '';
    this.variationsCodeToFilter = selectedTerms.join('-');
    this.processProductDetails(this.ResponseData, this.variationsCodeToFilter);
  }

  reinitializeSlick(): void {
    setTimeout(() => {
      // Determine the value for `arrows` based on `filteredVariation.length`
      const showArrows = this.filteredVariation?.length > 6;

      new Splide('#primary_slider', {
        type: 'slide', // Use 'slide' for showing multiple images.
        heightRatio: 0.15, // Adjust the height based on your needs.
        pagination: false, // Enable pagination.
        arrows: showArrows, // Set navigation arrows conditionally.
        perPage: 6, // Show 6 images at a time.
        perMove: 1, // Move 1 image at a time.
        gap: '10px', // Add space between images.
        // breakpoints: {           // Responsive settings.
        //   768: {
        //     perPage: 4,          // Show 4 images on smaller screens.
        //     gap: '8px',
        //   },
        //   480: {
        //     perPage: 2,          // Show 2 images on very small screens.
        //     gap: '6px',
        //   },
        // },
      }).mount();
    }, 0);
  }
  fetchAllProduct() {
    this.isLoading = true;
    this.payload.pageIndex = this.pagination.page;
    this.payload.pageSize = this.pagination.size;
    this.payload.userId = this.currentUserId;
    this.WebService.productList(this.payload).subscribe({
      next: (res: any) => {
        if (res?.status === 200 && res?.data) {
          this.WebService.productData(res);
        } else {
          this.similarProductDataList = [];
        }
        this.isLoading = false;
      },
      error: (error: any) => {
        this.isLoading = false;
        this.utility.toastAlert('error', error.message || 'An error occurred');
      },
    });
  }
  addToWishlist(id: any): void {
    if (this.currentUserId) {
      const payload = {
        user_id: this.currentUserId,
        product_id: id,
      };
      this.WebService.addWishlist(payload).subscribe({
        next: (res: any) => {
          if (res?.status === 200 && res?.data) {
            this.DataList = this.DataList.map((product: any) => {
              if (product.id === id) {
                product.wishlist = true;
              }
              return product;
            });
            // this.fetchAllProduct();
            this.utility.toastAlert('success', res.message);
          } else {
            this.utility.toastAlert('error', res.message);
          }
          this.isLoading = false;
        },
        error: (error: any) => {
          this.isLoading = false;
          this.utility.toastAlert(
            'error',
            error.message || 'An error occurred'
          );
        },
      });
    } else {
      this.router.navigate(['users/account/sign-in']);
    }
  }
  navigateToProductDetail(
    productId: string,
    dynamicSlug: string,
    variationsCode: string
  ): void {
    this.productId = productId;
    this.similarProduct = false;
    this.activeTerms = {};
    this.variationsCodeToFilter = variationsCode; // e.g., "3-4"
    this.termIdsToSelect = this.variationsCodeToFilter
      .split('-')
      .map((id) => parseInt(id, 10));
    // this.getProductDetail();

    const encryptedId = this.encryptId(productId);
    this.router.navigate([
      `product/${dynamicSlug}/${variationsCode}`,
      encryptedId,
    ]);
  }

  // openModal(data: any) {
  //   this.quantity = 1;
  //   this.product = data;
  //   this.variationsCodeToFilter = data.variations.variations_code;
  //   this.termIdsToSelect = this.variationsCodeToFilter
  //     .split('-')
  //     .map((id) => parseInt(id, 10));
  //   this.WebService.attributeWithVariationList(
  //     data.id,
  //     this.currentUserId
  //   ).subscribe((response: any) => {
  //     if (response.status === 200) {
  //       this.attrVariationDataList = response.data;
  //       this.variations = response.data.variations || [];
  //       this.setDefaultActiveTerm(this.termIdsToSelect);
  //       this.processProductDetails(
  //         this.attrVariationDataList,
  //         this.variationsCodeToFilter
  //       );
  //     } else {
  //     }
  //   });
  //   this.isModalOpen = true;
  // }
  // setDefaultActiveTerm(termIdsToSelect: any): void {
  //   this.attrVariationDataList.attributeTermData.forEach(
  //     (attributeData: any) => {
  //       const matchingTerm = attributeData.terms.find((term: any) =>
  //         termIdsToSelect.includes(term.id)
  //       );
  //       if (matchingTerm) {
  //         this.activeTerms[attributeData.id] = matchingTerm.id;
  //       }
  //     }
  //   );
  // }
  // setActiveTerms(attributeId: number, termId: number): void {
  //   this.activeTerms[attributeId] = termId;
  //   this.updateVariationsCodeToFilters();
  // }
  // updateVariationsCodeToFilters(): void {
  //   const selectedTerms = Object.values(this.activeTerms);
  //   this.variationsCodeToFilter = selectedTerms.join('-');
  //   this.processProductDetail(
  //     this.attrVariationDataList,
  //     this.variationsCodeToFilter
  //   );
  // }
  // processProductDetail(response: any, variationsCodeToFilter: any): void {
  //   const selectedVariation = this.variations.find(
  //     (variation: any) => variation.variations_code === variationsCodeToFilter
  //   );

  //   if (selectedVariation) {
  //     this.variant_id = selectedVariation.id || 0;
  //     this.filteredVariationData = selectedVariation || '';
  //     this.price =
  //       selectedVariation.discount_price ||
  //       selectedVariation.variations_price ||
  //       '';
  //     this.firstVariationImagePath =
  //       selectedVariation.images?.[0]?.image_path ||
  //       this.attrVariationDataList.product_images?.[0]?.image_path ||
  //       this.attrVariationDataList.product_thumbnail ||
  //       '';

  //     console.log(
  //       ' this.firstVariationImagePath',
  //       this.firstVariationImagePath
  //     );
  //   } else {
  //     this.variant_id = 0;
  //     this.price =
  //       response.data.discount_price || response.data.selling_price || '';
  //     this.firstVariationImagePath = '';
  //   }
  // }
  // closeModal(event: any) {
  //   if (event.target.id === 'myModal' || event.target.className === 'close') {
  //     this.isModalOpen = false;
  //   }
  // }

  // stopPropagation(event: any) {
  //   event.stopPropagation();
  // }
  plusMinusQuantity(action: string): void {
    if (action === 'plus') {
      this.quantity++;
    } else if (action === 'minus' && this.quantity > 1) {
      this.quantity--;
    }
  }
  // addToCartData(
  //   productId: any,
  //   quantity: any,
  //   currentPrice: any,
  //   product_type: any,
  //   variant_id: any
  // ): void {
  //   if (this.currentUserId) {
  //     const payload = {
  //       user_id: this.currentUserId,
  //       product_id: productId,
  //       quantity: quantity,
  //       product_type: product_type,
  //       variant_id: variant_id,
  //       currentPrice: currentPrice,
  //     };
  //     this.isCartLoading = true;
  //     this.WebService.addToCart(payload).subscribe({
  //       next: (res: any) => {
  //         if (res.status === 200 && res.data) {
  //           this.WebService.triggerReload();
  //           this.DataList = this.DataList.map((product: any) => {
  //             if (product.id === productId) {
  //               product.cart = true;
  //             }
  //             return product;
  //           });
  //           this.isModalOpen = false;
  //           // this.fetchAllProduct();
  //           this.utility.toastAlert('success', res.message);
  //         } else {
  //           this.utility.toastAlert('error', res.message);
  //         }
  //         this.isCartLoading = false;
  //       },
  //       error: (error: any) => {
  //         this.isCartLoading = false;
  //         this.utility.toastAlert(
  //           'error',
  //           error.message || 'An error occurred'
  //         );
  //       },
  //     });
  //   } else {
  //     this.router.navigate(['/users/account/sign-in']);
  //   }
  // }
  updateQuantity(
    data: string,
    productId: number,
    productQty: number,
    price: number
  ): void {
    let NQty = productQty;
    // let finalPrice = price;
    if (data === 'plus') {
      NQty++;
      // finalPrice = NQty * price;
    } else if (data === 'minus' && NQty > 1) {
      NQty--;
      // finalPrice = NQty * price;
    }

    if (NQty >= 1) {
      this.isLoadingqty = true;
      const payload = {
        user_id: this.currentUserId,
        product_id: productId,
        quantity: NQty,
        currentPrice: price,
      };

      this.WebService.getToCartProductQuantity(payload).subscribe({
        next: (res: any) => {
          if (res?.status === 200) {
            this.cartQuantity = NQty;
            this.cartPrice = +price * NQty;
            this.isLoadingqty = false;

            // this.skipCurrentComponent = true;
            // this.webService.triggerReload();
            // this.fetchAllCartList();
            // this.DataList = this.DataList.map((product: any) => {
            //   if (product.id === productId) {
            //     product.productNQty = NQty;
            //     product.currentPrice = price * NQty;
            //   }
            //   return product;
            // });
            // // Calculate total sum of currentPrice from cartItems
            // const totalCurrentPriceSum = this.DataList.reduce(
            //   (sum: number, item: any) => {
            //     return sum + (parseFloat(item.currentPrice) || 0);
            //   },
            //   0
            // );
            // this.totalPrice = totalCurrentPriceSum;
          } else {
            this.utility.toastAlert('error', res.message);
          }
          this.isLoadingqty = false;
        },
        error: (error: any) => {
          this.isLoadingqty = false;
          this.utility.toastAlert('error', error.message);
        },
      });
    }
  }
  buyNowstock(product_id: any, quantity: any, variationsCodeToFilter: any) {
    if (this.variant_id) {
      const variationsData = this.variations.find(
        (variation: any) => variation.id == this.variant_id
      );
      if (variationsData.stock < quantity) {
        this.utility.toastAlert(
          'error',
          'Only ' +
            variationsData.stock +
            ' items are available in stock. Please reduce the quantity before proceeding.'
        );

        return;
      }
    } else {
      if (this.DataList.product_stock < quantity) {
        this.utility.toastAlert(
          'error',
          'Only ' +
            this.DataList.product_stock +
            ' items are available in stock. Please reduce the quantity before proceeding.'
        );
        return;
      }
    }
    this.router.navigateByUrl(
      '/users/account/checkout/' +
        this.encryptId(product_id) +
        '/' +
        this.encryptId(quantity) +
        '/' +
        this.encryptId(variationsCodeToFilter) +
        '/' +
        this.encryptId('buynow')
    );
  }

  shareProduct() {
    if (navigator.share) {
      navigator.share({
        title: this.productName,
        text: 'Check out this awesome product!',
        url: this.productLink
      }).then(() => {
        // console.log('Product shared successfully');
      }).catch((error) => {
        // console.error('Error sharing', error);
        this.utility.toastAlert('error',error);
      });
    } else {
       this.utility.toastAlert('error', 'Sharing is not supported on this device/browser.');

    }
  }
  //  closePopup() {
  //   this.isPopupVisible = false;
  // }
}
